module.exports = __webpack_public_path__ + "img/report__teamwork_hpdk.abb24447.svg";